import { defineAsyncComponent } from "vue";

// The editor surfaces (the email editor, the reusable draft page, the custom
// template page) lazy-load these heavy editors. Declaring them once keeps the
// import paths in a single place.
//
// Under Vitest we eagerly resolve each chunk instead of wrapping it in
// defineAsyncComponent: the <Suspense> boundaries that host these editors
// otherwise race a dynamic import() that flushPromises can't drain in jsdom, so
// a snapshot lands on either the loading fallback or the resolved editor at
// random. Eager resolution makes that deterministic. Production stays lazy —
// `import.meta.env.VITEST` is false there, so the await branch is compiled out.
// Same split as pages/home/components/LazyOnboardingView.ts.

export const TiptapEditor = import.meta.env.VITEST
  ? (await import("./TiptapEditor.vue")).default
  : defineAsyncComponent(() => import("./TiptapEditor.vue"));

export const PlainEditor = import.meta.env.VITEST
  ? (await import("./PlainEditor.vue")).default
  : defineAsyncComponent(() => import("./PlainEditor.vue"));

export const NakedEditor = import.meta.env.VITEST
  ? (await import("./NakedEditor.vue")).default
  : defineAsyncComponent(() => import("./NakedEditor.vue"));
